export default "__VITE_ASSET__CiU14Qyz__"